import logo from "@/assets/logo-top-128.png";

// The logo carries its own rounded blue tile, so it is shown as-is -- no background box around it.
// Source artwork: frontend/branding/logo-TOP-source.png.
export default function AppLogo({ className = "h-10 w-10" }) {
  return <img src={logo} alt="TERPADU-OP RSCM" className={`${className} shrink-0 select-none`} draggable={false} />;
}
